import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { WorkflowApplicationsJanusServiceData } from './workflow-applications-janus.model';
import { ItemSearchOptionFieldOption } from 'src/app/components/filter-list/models/filterClasses';

@Injectable({ providedIn: 'root' })
export class WorkflowApplicationsJanusService {
  private dataSource = new BehaviorSubject<
    WorkflowApplicationsJanusServiceData
  >({
    searchText: [],
    parcelId: '',
    propertyAddress: '',
    propertyOwner: '',
    filterInputs: [],
    reRunJanusApplicationDataTable: false,
    attributeFilterInputs: [],
    inlineApplicationSummaryDetails: {
      canEditApplicationNumber: false,
      clientApplicationNumber: '',
      combinedApplicationNumber: '',
      canViewVersion: false,
      workflowId: '',
      versionId: '',
      canEditCompletedApplication: false,
      canReopenApplication: false,
      
      showReopenApplicationButton: false,
      categoriesDefined: false,
      appDescription: '',
      updateDescp: false,
      userName: '',
      updateUserNameAndAppNo: false
    },
    scrollToExpandedRow: false,
    runSubmitForCategoryActivityDataId: null,
    showRelateToPermitView: false,
    linkedApplications:[],
    goToFirstPage: false,
    // Added by amisha on 2026-06-02 so the filter attribute list can mirror the table's current visible headers.
    // Reason: Janus attribute options should stay aligned with hide/show column changes, including dynamic dataset headers.
    visibleAttributeColumns: [],
    reRunCurrentInlineActivity: null,
    consolidatedInspection: {
      activity: null,
      processWay: 'None'
    }
  });

  data$ = this.dataSource.asObservable();

  /** Used to replace or partially update app data */
  setData(data: WorkflowApplicationsJanusServiceData) {
    this.dataSource.next(data);
  }

  /** Getter for value (optional) */
  getData(): WorkflowApplicationsJanusServiceData {
    return this.dataSource.value;
  }

  private bulkSelectionSubject = new BehaviorSubject<any[]>([]);
  bulkSelection$ = this.bulkSelectionSubject.asObservable();

  setBulkSelection(data: any[]) {
    this.bulkSelectionSubject.next(data);
  }

  private refreshTableSubject = new Subject<void>();
  refreshTable$ = this.refreshTableSubject.asObservable();

  triggerTableRefresh() {
    this.refreshTableSubject.next();
  }
}
